import { render } from "./PaymentDepositType.vue?vue&type=template&id=2d382d51"
import script from "./PaymentDepositType.vue?vue&type=script&lang=js"
export * from "./PaymentDepositType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__